import { StyleSheet } from 'react-native';
import { themes } from '../../../theme/theme';

export const getHeaderStyle = (isSelected: boolean, isExpanded: boolean) => [
  styles.cardHeaderSection,
  isSelected && styles.selectedHeaderSection,
  isSelected && isExpanded && styles.selectedHeaderSectionExpanded,
];

export const styles = StyleSheet.create({
  cardContainer: {
    borderWidth: 1,
    borderRadius: 8,
    borderColor: themes.light.gray_blue[6],
    backgroundColor: themes.light.white[1],
  },
  cardHeaderSection: {
    padding: 16,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    backgroundColor: themes.light.white[1],
  },
  selectedHeaderSection: {
    backgroundColor: themes.light.brand_blue[7],
    borderTopWidth: 2,
    borderStartWidth: 2,
    borderEndWidth: 2,
    borderBottomWidth: 2,
    borderColor: themes.light.teal[3],
    borderRadius: 8,
  },
  selectedHeaderSectionExpanded: {
    borderBottomWidth: 0,
    borderRadius: 0,
  },
  checkIconContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 24,
    height: 24,
    backgroundColor: themes.light.teal[3],
    borderBottomRightRadius: 12,
    borderTopLeftRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkIcon: {
    width: 12,
    height: 12,
    tintColor: themes.light.white[1],
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  providerLogo: {
    width: 80,
    height: 12,
    marginRight: 12,
  },
  priceText: {
    color: themes.light.brand_blue[1],
    fontWeight: 'bold',
    marginBottom: 4,
  },
  coverageText: {
    color: themes.light.gray_blue[3],
  },
  arrowIconContainer: {
    alignItems: 'flex-end',
  },
  arrowIcon: {
    width: 20,
    height: 20,
  },
  details: {
    gap: 16,
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: themes.light.white[1],
  },
  selectedDetailsSection: {
    borderBottomWidth: 2,
    borderStartWidth: 2,
    borderEndWidth: 2,
    // borderTopWidth: 0,
    borderColor: themes.light.teal[3],
  },
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: themes.light.gray_blue[6],
  },
  noBorder: {
    borderBottomWidth: 0,
  },
  label: {
    color: themes.light.gray_blue[3],
  },
  link: {
    color: themes.light.teal[3],
    textDecorationLine: 'underline',
  },
});
